import React from 'react';
import professionalAttireImage from '@/assets/uniforms/professional-attire-belt-and-above.png';
import optimizedProfessionalAttireImage from '@/assets/uniforms/professional-attire-belt-and-above-optimized.svg';

export default function ProfessionalAttireSvg({ className = '', title = null, style = null }) {
  return (
    <span className={className} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', ...style }}
      role={title ? 'img' : undefined} aria-label={title || undefined} aria-hidden={title ? undefined : true}
      data-template="professional-attire-fixed-png-v3">
      <picture style={{ display: 'block', width: '100%', height: '100%' }}>
        <source type="image/svg+xml" srcSet={optimizedProfessionalAttireImage} />
        <img src={professionalAttireImage} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center', display: 'block', transform: 'scale(1.9)', transformOrigin: 'center' }} />
      </picture>
    </span>
  );
}
